const KEY = 'beelday-presenter-speakers'

/**
 * The speakers the trainer chose, kept in `localStorage`: per browser, not
 * per session or tab, because device ids are stable per origin and the
 * trainer's speakers are the same at the next training. A browser that
 * refuses storage (private mode) simply forgets the choice.
 */
export const readSavedSpeakers = (): string | null => {
	try {
		return window.localStorage.getItem(KEY) || null
	} catch (e) {
		return null
	}
}

/** `null` forgets the choice: the system default. */
export const saveSpeakers = (deviceId: string | null): void => {
	try {
		if (deviceId) {
			window.localStorage.setItem(KEY, deviceId)
		} else {
			window.localStorage.removeItem(KEY)
		}
	} catch (e) {
		// Not kept: the next presentation starts on the system default.
	}
}
